import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import {
  required,
  uniq,
  maxLength,
  nullable,
} from '../../shared/forms/validators';

const semicolonRegex = /;/;

const noSemicolon = (label, validator) =>
  validator.test('noSemicolon', `${label} cannot contain a semicolon`, function(value) {
    return !semicolonRegex.exec(value);
  });

export const TAG_NAME_MAX_LENGTH = 30;
export const TAG_DESCRIPTION_MAX_LENGTH = 240;

const schema = [
  {
    name: 'tagName',
    component: InputFormik,
    meta: { label: 'Tag Name' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [
        required,
        maxLength(TAG_NAME_MAX_LENGTH),
        uniq([], 'Tag name already exists'),
      ],
    },
    additionalProps: {
      required: true,
    },
  },
  {
    name: 'description',
    component: InputFormik,
    meta: { label: 'Description' },
    options: {
      yupType: yupString(),
      validationRules: [
        required,
        noSemicolon,
        maxLength(TAG_DESCRIPTION_MAX_LENGTH),
        uniq(['tagName'], 'Description already exists'),
      ],
    },
    additionalProps: {
      required: true,
    },
  },
  {
    name: 'subTag',
    component: SelectFormik,
    meta: { label: 'Sub Tag', optionsKey: 'subTagsListOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true },
  },
];

export default schema;
